<script>
import { nlToBr } from '@utils/index'
export default {
  props: {
    aboutCompany: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      flowTitle: '甄選流程',
      flowDetail: '我們誠摯的邀請您加入零壹這個大家庭！歡迎了解零壹的甄選流程：',
      flowList: [],
    }
  },
  created() {
    const vm = this
    vm.flowList = vm.aboutCompany.step
  },
  methods: {
    nlToBr(item) {
      return nlToBr(item)
    },
  },
}
</script>
<template>
  <div :class="$style.flow">
    <div class="flow__box">
      <div class="container">
        <div class="flow-box">
          <BaseSectionTitle title="甄選流程" class="text-center" />
          <p class="detail">{{ flowDetail }}</p>
          <div v-for="(item, index) of flowList" :key="index" class="block">
            <span class="number">{{ index + 1 }}</span>
            <p class="inner-title">{{ item.title }}</p>
            <!-- <p v-if="index === 3" class="inner-detail">
              <span v-for="(child, childIndex) of item.detail" :key="childIndex">{{ childIndex + 1 }}. {{ child.text }}<br /></span>
            </p>
            <p v-else class="inner-detail">{{ item.detail }}</p> -->
            <p class="inner-detail" v-html="nlToBr(item.description)"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" module>
.flow {
  :global {
    .flow {
      &__box {
        .container {
          .flow-box {
            margin: 70px 0px;
            padding-top: 70px;
            background: var(---ffffff) 0% 0% no-repeat padding-box;
            background: #ffffff 0% 0% no-repeat padding-box;
            box-shadow: 0px 0px 8px #21455829;
            display: flex;
            flex-wrap: wrap;
            flex-direction: column;
            .detail {
              margin-bottom: 60px;
              font-size: 1.125rem;
              color: $color-gray-6;
              text-align: center;
            }
            .block {
              width: 878px;
              position: relative;
              padding-left: 63px;
              border-left: 1px solid $color-primary;
              padding-bottom: 70px;
              margin-left: 14.25rem;
              .number {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 52px;
                height: 52px;
                border: 1px solid $color-primary;
                position: absolute;
                top: 0;
                left: -25px;
                border-radius: 30px;
                color: $color-primary;
                z-index: 5;
                background-color: #ffffff;
              }
              .inner-title {
                font-size: 1.5rem;
                color: $color-gray-8;
                font-weight: 500;
              }
              .inner-detail {
                font-size: 1.25rem;
                color: $color-gray-6;
                line-height: 2;
              }
            }
            @include max-xl {
              .block {
                width: 700px;
                margin-left: 8rem;
              }
            }
            @include max-lg {
              .block {
                width: 450px;
                margin-left: 8rem;
              }
            }
            @include max-md {
              .detail {
                margin-bottom: 30px;
                font-size: 0.75rem;
              }
              .block {
                width: 25rem;
                margin-left: 7rem;
                .number {
                  width: 34px;
                  height: 34px;
                  left: -17px;
                }
                .inner-title {
                  font-size: 1rem;
                }
                .inner-detail {
                  font-size: 0.65rem;
                  line-height: 1.5;
                }
              }
            }
            @include max-sm {
              .block {
                width: 70%;
                padding-left: 40px;
                margin-left: 4rem;
                padding-bottom: 20px;
              }
            }
            @include max-2sm {
              .detail {
                text-align: left;
                margin: 0px 20px 30px;
              }
              .block {
                margin-left: 3rem;
              }
            }
            .block:nth-last-child(1) {
              border-left: none;
            }
          }
          @include max-md {
            .flow-box {
              padding-top: 30px;
            }
          }
        }
      }
    }
  }
}
</style>